import { render, staticRenderFns } from "./SearchOverview.vue?vue&type=template&id=34617590&scoped=true"
import script from "./SearchOverview.vue?vue&type=script&lang=js"
export * from "./SearchOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34617590",
  null
  
)

export default component.exports